export { FaqModule } from './FaqModule';
export { getHdpFaqQuestions, buildFaqJsonLd } from './faqController';
export type { FaqQuestion, FaqAnswerType } from './faqController';
